import { Series, useVideoConfig, Audio } from 'remotion';

type AudioTrack = { src: string; duration: number; label?: string };

export type AudioSequenceProps = {
  audioTracks: AudioTrack[];
};

export const AudioSequence: React.FC<AudioSequenceProps> = ({ audioTracks }) => {
  const { fps } = useVideoConfig();

  return (
    <Series>
      {audioTracks.map((t, i) => {
        const frames = t.duration * fps;
        return (
          <Series.Sequence key={i} durationInFrames={frames}>
            <Audio src={t.src} />
          </Series.Sequence>
        );
      })}
    </Series>
  );
};
